module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "clickhouse.53526bb6.svg";